import React from 'react';

import { ReactComponent as ArrowLeft } from './arrow-left.svg';
import { ReactComponent as ArrowRight } from './arrow-right.svg';
import { ReactComponent as MinimalisticArrow } from './minimalist-arrow.svg';
import { ReactComponent as WhiteArrow } from './white-arrow.svg';

type IconComponentProps = { name: string };
type IconTypes = { [name: string]: ReactSVGComponent };

const iconTypes: IconTypes = {
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  whiteArrow: WhiteArrow,
  minimalisticArrow: MinimalisticArrow,
};

const IconComponent = ({ name, ...props }: IconComponentProps) => {
  const Icon = iconTypes[name];
  return <Icon {...props} />;
};

export default IconComponent;
